import { Component } from "react";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import Cookies from "universal-cookie";
import { httpPost } from "../util/http";
import { Navigate } from "react-router-dom";
import StatusAlert from "../ui/StatusAlert";
import SenhaInput from "../ui/SenhaInput";
import Username from "../ui/Username";

export default class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            usernameErr: false,
            senha: '',
            senhaErr: false,
            showAlert: false,
            loading: false,
            msg: '',
            extraMsg: '',
            toHome: false,
        }
    }

    onSubmit(e) {
        e.preventDefault();

        if (this.state.username.length < 1) {
            this.setState({ usernameErr: true })
            return;
        }

        if (this.state.senha.length < 1) {
            this.setState({ senhaErr: true })
            return;
        }

        this.setState({
            showAlert: false,
            loading: true
        });

        httpPost('/login',
            {
                login: this.state.username,
                senha: this.state.senha,
            },

            user => {
                let cookies = new Cookies();
                cookies.set('user', user, { path: '/', maxAge: 604800 });//7 dias
                console.log(user)
                this.setState({ toHome: true });
            },

            error => {
                this.setState({
                    showAlert: true,
                    loading: false
                });
                if (error.type === 'AuthenticationException') {
                    this.setState({
                        msg: 'Usuário ou senha inválidos.',
                        extraMsg: error.message
                    });
                } else {
                    this.setState({
                        msg: 'Falha no login.',
                        extraMsg: error.message
                    });
                }
            },

            false //sem cache
        );
    }

    render() {
        return (
            <Stack height={"100vh"} alignItems="center" justifyContent="center">
                <form onSubmit={event => this.onSubmit(event)}>
                    <Stack width={400} gap={2} alignItems="center">
                        <Box component="img" src="res/cm_logo.png" height={107} />
                        <Typography mt={2} variant="subtitle2" color="primary">Entre com as suas credenciais para fazer login:</Typography>
                        <Stack width={"calc(100% - 30px)"} gap={2}>
                            <Username value={this.state.username} onChange={username => this.setState({ username, usernameErr: false, showAlert: false })} error={this.state.usernameErr} />
                            <SenhaInput value={this.state.senha} onChange={senha => this.setState({ senha, senhaErr: false, showAlert: false })} error={this.state.senhaErr} />
                        </Stack>
                        {this.state.showAlert &&
                            <Stack width="calc(100% - 30px)"><StatusAlert type="err" msg={this.state.msg} extra={this.state.extraMsg} onClose={() => this.setState({ showAlert: false })} /></Stack>}
                        {this.state.loading ? <CircularProgress /> : <Button type="submit" variant="outlined">Entrar</Button>}
                    </Stack>
                    {this.state.toHome && <Navigate to='/' />}
                </form>
            </Stack>
        );
    }
}
